import React, {ReactNode} from 'react';
import Main from './Main';
import Page, {PageType} from '@episerver/spa-core/Page';
import EquipmentListPageData from '../../../Models/Content/EquipmentListPageData';

export default class EquipmentListPage extends Page<EquipmentListPageData> {
  public render(): ReactNode | null {
    return <Main context={this.getContext()} iContent={this.props.data} />;
  }
}
